import { useQuery } from '@tanstack/react-query';
import { courseAppearanceService } from '@/services/course-appearance.service';
import { appearanceKeys } from './queryKeys';

export function useCourseMenuItems(productId: string, enabled = true) {
  return useQuery({
    queryKey: appearanceKeys.menuItems(productId),
    queryFn: () => courseAppearanceService.getMenuItems(productId),
    enabled: enabled && !!productId,
  });
}
